import { render, staticRenderFns } from "./MessageChipsList.vue?vue&type=template&id=ca5ae83c&scoped=true"
import script from "./MessageChipsList.vue?vue&type=script&lang=js"
export * from "./MessageChipsList.vue?vue&type=script&lang=js"
import style0 from "./MessageChipsList.vue?vue&type=style&index=0&id=ca5ae83c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5ae83c",
  null
  
)

export default component.exports